import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { ROLES } from "../models/Roles";

const RequireAuth = ({ allowedRoles }) => {
  const { auth } = useAuth();
  const location = useLocation();

  if (auth?.roles?.find((role) => role === ROLES.Disabled)) {
    return <Navigate to="/disabled" state={{ from: location }} replace />;
  }
  if (auth?.roles?.find((role) => role === ROLES.Pending)) {
    return <Navigate to="/pending" state={{ from: location }} replace />;
  }

  return auth?.roles?.find((role) => allowedRoles?.includes(role)) ? (
    <Outlet />
  ) : auth?.user ? (
    <Navigate to="/unauthorized" state={{ from: location }} replace />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default RequireAuth;
